import React from 'react'
import logo from '../assets/img/logo.png'
import { TbCaretDownFilled } from "react-icons/tb";
import { FiSearch } from "react-icons/fi";
import burger from '../assets/img/burger.png'

export const Header = () => {
  return (
    <div id="header">
        <div className="container">
            <div className="header">
              <div className="logo-header">
                <img src={logo} alt="" />
              </div>
              <div className="pages">
                <div className="page">Купить крипто <TbCaretDownFilled size={22}/></div>
                <div className="page">Рынки</div>
                <div className="page">Спотовая <TbCaretDownFilled size={22}/></div>
                <div className="page">Фьючерсы <span className='multiplier'>500x</span><TbCaretDownFilled size={22}/></div>
                <div className="page">Сбережения <TbCaretDownFilled size={22}/></div>
                <div className="page">Мероприятия <TbCaretDownFilled size={22}/></div>
                <div className="page">Еще <TbCaretDownFilled size={22}/></div>
                <div className="page">Эйфория ETHFI</div>
              </div>
              <div className="header-elems">
                <div className="header-search">
                  <FiSearch size={24}/>
                </div>
                <span className='header-btn enter'>Войти</span>
                <button className='header-btn register'>Регистрация</button>
                <div className="burger">
                  <img src={burger} alt="" />
                </div>
              </div>
            </div>
        </div>
    </div>
  )
}
